module.exports = __webpack_public_path__ + "static/img/addquestion-likert.3c8c0d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/addquestion-likert.png
// module id = Aii+
// module chunks = 1